import { render, staticRenderFns } from "./RightsButtons.vue?vue&type=template&id=0c22a80c&scoped=true"
import script from "./RightsButtons.vue?vue&type=script&lang=js"
export * from "./RightsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22a80c",
  null
  
)

export default component.exports